import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const cashback = (theme: Theme) => css`
  h2 {
    font-size: ${pxToRem(28)};
    max-width: ${width.modal.compact};
    margin: 0 auto ${size[24]};
    text-align: start;

    & > span {
      color: ${theme.palette.primary.mainContrast};
    }

    ${breakpoint.up('smMd')} {
      text-align: center;
      font-size: ${pxToRem(48)};
      font-weight: 600;
      letter-spacing: -1px;
      margin-bottom: ${size[32]};
    }
  }
`

export const container = css`
  margin: 0 auto;
  padding: 0 ${size[20]};
  max-width: ${width.container.large};
`

export const wrapper = css`
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
`

export const benefits = css`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${size[16]};
  justify-items: center;

  ${breakpoint.up('smMd')} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${size[24]};
  }
`

export const affiliateBenefits = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${size[16]};
  justify-items: center;

  ${breakpoint.up('smMd')} {
    grid-template-columns: repeat(4, 1fr);
    gap: ${size[24]};
  }
`
